import type { ArcanaReadingQueueCountsDto } from '@lunary/api-client'
import { FILTERS } from './labels'
import type { QueueFilter } from './labels'
import styles from './readings.module.css'

type Props = {
  value: QueueFilter
  counts: ArcanaReadingQueueCountsDto | undefined
  onChange: (f: QueueFilter) => void
}

export function FilterTabs({ value, counts, onChange }: Props) {
  return (
    <div className={styles.tabs} role="tablist" aria-label="Фильтр разборов">
      {FILTERS.map((f) => {
        const n = counts?.[f.id]
        return (
          <button key={f.id} type="button" role="tab" aria-selected={value === f.id} className={styles.tab} onClick={() => onChange(f.id)}>
            {f.label}
            {n !== undefined && (
              <span className={styles.tabCount} data-hot={f.id === 'new' && n > 0 ? 'true' : undefined}>
                {n}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}
